import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  FIELD_FILLING_TYPES,
  getFieldProps,
} from '../../../../utils/fields/getFieldProps';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import PasswordInput from '../../../TextInput/PasswordInput';
import DateDropdown from '../../../common/DateDropdown';
import SelectCustom from '../../../SelectCustom';
import TextInput from '../../../TextInput';
import ErrorBlock from '../../../common/ErrorBlock';
import { SSNField } from '../../../SSNField';
import { selectSsnHidingEnabled } from '../../../../redux/data/selectors';

const {
  LAST_NAME,
  FIRST_NAME,
  MIDDLE_NAME,
  DOB,
  GENDER,
  SSN,
  NAME_SUFFIX,
} = PROFILE_FIELDS_TYPES;

export const PersonalInfoForm = ({
  firstName,
  lastName,
  middleName,
  validateErrors,
  nameSuffixList,
  genderList,
  nameSuffix,
  dob,
  gender,
  ssn,
  formatMessage,
  onChange,
}) => {
  const ssnHidingEnabled = useSelector(selectSsnHidingEnabled);

  const makeProfileField = getFieldProps(formatMessage, onChange);

  return (
    <Fragment>
      {validateErrors.careUserId && (
        <ErrorBlock
          errors={formatMessage({ id: 'dependent.form.careUserIdError' })}
          className="mt3"
        />
      )}
      {/*     F I R S T   N A M E     */}
      <TextInput {...makeProfileField(FIRST_NAME)} value={firstName} />
      <FormErrorBlock type={FIRST_NAME} errors={validateErrors} />
      {/*     M I D D L E   N A M E     */}
      <TextInput {...makeProfileField(MIDDLE_NAME)} value={middleName} />
      <FormErrorBlock type={MIDDLE_NAME} errors={validateErrors} />
      {/*     L A S T   N A M E     */}
      <TextInput {...makeProfileField(LAST_NAME)} value={lastName} />
      <FormErrorBlock type={LAST_NAME} errors={validateErrors} />
      {/*     N A M E   S U F F I X     */}
      <SelectCustom
        {...makeProfileField(NAME_SUFFIX)}
        options={nameSuffixList}
        value={nameSuffix}
        needUpdateDefaultValue
      />
      {/*     G E N D E R     */}
      <SelectCustom
        {...makeProfileField(GENDER)}
        options={genderList}
        value={gender}
        needUpdateDefaultValue
      />
      {/*     D O B     */}
      <DateDropdown {...makeProfileField(DOB)} value={dob} />
      {/*     S S N     */}
      {!ssnHidingEnabled && (
        <SSNField
          formatMessage={formatMessage}
          children={
            <PasswordInput
              {...makeProfileField(SSN, FIELD_FILLING_TYPES.OPTIONAL)}
              value={ssn}
            />
          }
        />
      )}
      <FormErrorBlock type={SSN} errors={validateErrors} />
    </Fragment>
  );
};

PersonalInfoForm.propTypes = {
  validateErrors: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({ description: PropTypes.string }),
  ]),
  nameSuffixList: PropTypes.array,
  genderList: PropTypes.array,
  nameSuffix: PropTypes.string,
  ssn: PropTypes.string,
  formatMessage: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  gender: PropTypes.string,
  middleName: PropTypes.string,
  onChange: PropTypes.func,
  dob: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentPersonalInfo/PersonalInfoForm/index.jsx